import React from 'react'

export default function Home() {
    return (
        <div>
            <h2>Welcome to the Home Page</h2>
            <div className="container">
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe cumque fuga doloribus ipsam quia itaque dolores! Iure non voluptate explicabo, molestias veritatis inventore accusantium nobis at, ex, harum voluptas. Obcaecati.</p>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt maxime saepe iste enim impedit aperiam eaque nostrum laborum reprehenderit facere cum ipsum, molestiae aliquid a.</p>
            </div>
        </div>
    )
}
